<template>
    <div>
        <editar v-model="activeEditar"  :row="selectedRow" @refreshTable="getFiltros"></editar>
        <eliminar v-model="activeEliminar" :row="selectedRow" @refreshTable="getFiltros"></eliminar>
        <vs-table>
            <template #thead>
            <vs-tr>
                <vs-th >
                    Componente académico
                </vs-th>
                <vs-th >
                    Institución
                </vs-th>
                <vs-th>
                    Rango de fechas
                </vs-th>
                <vs-th>
                    Acciones
                </vs-th>
            </vs-tr>
            </template>
            <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in users"
                :data="tr"
            >
                <vs-td>
                    <p class="mb-0 text-uppercase"><small>Detalle componente académico</small></p>
                    <p class="mb-2" style="font-size: 14px;"><strong>{{tr.detalle_componente_academico}}</strong></p>
                    <p class="mb-0 text-uppercase"><small>Componente académico</small></p>
                    <p class="mb-2" style="font-size: 14px;"><strong>{{tr.componente_academico}}</strong></p>
                </vs-td>
                <vs-td>
                    <p class="mb-0"><strong>{{tr.institucion}}</strong></p>
                    <p class="mb-0"><strong>{{tr.ciclo_escolar}}</strong></p>
                    <md-chip v-if="tr.activo_boleta === 'si'" class="mini-chip col-green mx-0 mb-1" ><strong>Boleta activa</strong></md-chip>
                </vs-td>
                <vs-td>
                    <small class="text-uppercase">Fecha de inicio</small> 
                    <p class="mb-1" style="font-size: 14px;"><strong><i class="far fa-calendar-alt"></i> {{ tr.fecha_inicio }}</strong></p>
                    <small class="text-uppercase">Fecha final</small> 
                    <p class="mb-0" style="font-size: 14px;"><strong><i class="far fa-calendar-alt"></i> {{ tr.fecha_fin }}</strong></p>
                </vs-td>
                <vs-td v-if="tr != null">
                    <md-menu md-size="small"  md-align-trigger>
                        <md-button class="md-icon-button" md-menu-trigger>
                            <i class="fas fa-ellipsis-v"></i>
                        </md-button>

                        <md-menu-content>
                            <md-menu-item @click="activeEditar = !activeEditar;  selectedRow = tr;">
                                Editar
                            </md-menu-item>
                            <md-menu-item @click="activeEliminar = !activeEliminar;  selectedRow = tr;">
                                Eliminar
                            </md-menu-item>
                        </md-menu-content>
                    </md-menu>
                </vs-td>
            </vs-tr>
            </template>
            <template #notFound>
                No hay información
            </template>

        </vs-table>
    </div>
</template>
<script>
import editar from './modal/editar.vue'
import eliminar from './modal/eliminar.vue'
import academico from '../../../../api/requests/academico.js'
export default {
    props:[
        'users'
    ],
    data(){
        return{
            activeEditar: false,
            selectedRow: [],
            activeEliminar: false
        }
    },
    components:{
        editar,
        eliminar,
    },
    methods:{
        getFiltros(institucion, cicloEscolar){
            this.$emit('refreshTable', institucion, cicloEscolar, programa)
        }
    },
    watch:{
        
    }
}
</script>

<style scoped>
    .objetfitcover > img{
        width: 70px;
        height: 70px;
        object-fit: cover;
        border-radius: 15px;
    }
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }

    .mini-chip{
        width: 100% !important;
        text-align: center !important;
        height: 24px;
        line-height: 24px;
    }
</style>

        